import { render, staticRenderFns } from "./Deliver.vue?vue&type=template&id=1d159a42&scoped=true&"
import script from "./Deliver.vue?vue&type=script&lang=js&"
export * from "./Deliver.vue?vue&type=script&lang=js&"
import style0 from "./Deliver.vue?vue&type=style&index=0&id=1d159a42&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d159a42",
  null
  
)

export default component.exports